import { CITY_POSTER_PDF_URL, POSTER_PDF_DRIVE_URL, POSTER_PNG_URL } from "../posterAssets";
import { LOU_CHEYMOL_URL } from "@/remerciementsAssets";

export function PosterSection() {
  return (
    <section className="section poster-section" id="affiche">
      <div className="section-heading">
        <p className="kicker">L'affiche</p>
      </div>
      <div className="poster-showcase">
        <div className="poster-large">
          <img
            className="poster-image"
            src={POSTER_PNG_URL}
            alt="Affiche du spectacle Les Apprentis Dictateurs"
          />
        </div>
        <div className="poster-copy">
          <p>
  Les Apprentis Dictateurs passent forcément proche de chez vous, et si ce n'est pas le cas, on peut s'arranger !
  <br />
  <br />
  Affiche réalisée par <a href={LOU_CHEYMOL_URL}>Lou CHEYMOL</a>
</p>
          <div className="poster-actions">
            <a
              className="button secondary"
              href={POSTER_PDF_DRIVE_URL}
              rel="noopener noreferrer"
              target="_blank"
            >
              Télécharger l'affiche en PDF
            </a>
            <a
              className="button secondary"
              href={CITY_POSTER_PDF_URL}
              rel="noopener noreferrer"
              target="_blank"
            >
              Télécharger l'affiche de ma ville en PDF
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
